<template>
  <div>
    <div>
      <div
        ref="createNotificationModal"
        id="createNotificationModal"
        class="modal fade modal-create-notification"
        tabindex="-1"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content max-width">
            <div class="modal-header">
              <h5 class="modal-title mb-0">New action</h5>
              <span class="view-logs-modal-close" @click="closeModal()"
                ><img :src="close_icon"
              /></span>
            </div>
            <div class="modal-body">
              <div class="body-container">
                <Sidebar />

                <div class="tab">
                  <div>
                    <ActionTab v-if="sidebar_notification_option == 1" />
                    <EventTab v-if="sidebar_notification_option == 2" />
                    <SettingsTab v-if="sidebar_notification_option == 3" />
                    <ChannelsTab v-if="sidebar_notification_option == 4" />
                  </div>
                  <div class="buttons">
                    <div>
                      <button class="no-bg">Cancel</button>
                    </div>
                    <div class="d-flex">
                      <button
                        :class="{ border: sidebar_notification_option == 1 }"
                        @click="prevOption"
                      >
                        Prev
                      </button>
                      <button
                        v-if="
                          (sidebar_notification_option == 3 &&
                            form_action == 1) ||
                          (sidebar_notification_option == 4 && form_action == 0)
                        "
                        @click="save"
                      >
                        Save
                      </button>
                      <button v-else @click="nextOption">Next</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionTab from "./ActionTab";
import ChannelsTab from "./ChannelsTab.vue";
import SettingsTab from "./SettingsTab.vue";
import CloseIcon from "../../../../../../assets/images/close.svg";
import EventTab from "./EventTab.vue";
import Sidebar from "./Sidebar.vue";
import $ from "jquery";
import { Modal } from "bootstrap";
import { mapState } from "vuex";

export default {
  name: "CreateNotificationModal",
  components: { ActionTab, ChannelsTab, EventTab, SettingsTab, Sidebar },
  props: {
    show: {
      type: Boolean,
    },
    isEdit: Boolean,
  },
  data() {
    return {
      close_icon: CloseIcon,
      error: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="20" height="20" rx="10" fill="#DC3545" fill-opacity="0.3"/>
            <path d="M12.4999 7.49992C12.4218 7.42181 12.3158 7.37793 12.2053 7.37793C12.0949 7.37793 11.9889 7.42181 11.9108 7.49992L9.99992 9.41076L8.08909 7.49992C8.01095 7.42181 7.90499 7.37793 7.79451 7.37793C7.68402 7.37793 7.57806 7.42181 7.49992 7.49992C7.42181 7.57806 7.37793 7.68402 7.37793 7.79451C7.37793 7.90499 7.42181 8.01095 7.49992 8.08909L9.41076 9.99992L7.49992 11.9108C7.42181 11.9889 7.37793 12.0949 7.37793 12.2053C7.37793 12.3158 7.42181 12.4218 7.49992 12.4999C7.57806 12.578 7.68402 12.6219 7.79451 12.6219C7.90499 12.6219 8.01095 12.578 8.08909 12.4999L9.99992 10.5891L11.9108 12.4999C11.9889 12.578 12.0949 12.6219 12.2053 12.6219C12.3158 12.6219 12.4218 12.578 12.4999 12.4999C12.578 12.4218 12.6219 12.3158 12.6219 12.2053C12.6219 12.0949 12.578 11.9889 12.4999 11.9108L10.5891 9.99992L12.4999 8.08909C12.578 8.01095 12.6219 7.90499 12.6219 7.79451C12.6219 7.68402 12.578 7.57806 12.4999 7.49992Z" fill="#1D1E25"/>
            </svg> Error`,
      success: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="20" height="20" rx="10" fill="#8BF125" fill-opacity="0.3"/>
              <g clip-path="url(#clip0_1634_940)">
              <path d="M14.2995 6.84625L8.5416 12.6038C8.50288 12.6426 8.45688 12.6735 8.40622 12.6945C8.35556 12.7155 8.30124 12.7264 8.24639 12.7264C8.19153 12.7264 8.13722 12.7155 8.08656 12.6945C8.0359 12.6735 7.98989 12.6426 7.95118 12.6038L5.72451 10.375C5.6858 10.3361 5.63979 10.3053 5.58913 10.2843C5.53848 10.2632 5.48416 10.2524 5.4293 10.2524C5.37445 10.2524 5.32013 10.2632 5.26947 10.2843C5.21881 10.3053 5.17281 10.3361 5.1341 10.375C5.09523 10.4137 5.06439 10.4597 5.04335 10.5104C5.02231 10.561 5.01147 10.6154 5.01147 10.6702C5.01147 10.7251 5.02231 10.7794 5.04335 10.83C5.06439 10.8807 5.09523 10.9267 5.1341 10.9654L7.3616 13.1925C7.59657 13.427 7.91501 13.5588 8.24701 13.5588C8.57901 13.5588 8.89745 13.427 9.13243 13.1925L14.8899 7.43625C14.9287 7.39755 14.9595 7.35157 14.9805 7.30095C15.0015 7.25033 15.0123 7.19606 15.0123 7.14125C15.0123 7.08645 15.0015 7.03218 14.9805 6.98156C14.9595 6.93094 14.9287 6.88496 14.8899 6.84625C14.8512 6.80739 14.8052 6.77655 14.7546 6.75551C14.7039 6.73446 14.6496 6.72363 14.5947 6.72363C14.5399 6.72363 14.4855 6.73446 14.4349 6.75551C14.3842 6.77655 14.3382 6.80739 14.2995 6.84625Z" fill="#1D1E25"/>
              </g>
              <defs>
              <clipPath id="clip0_1634_940">
              <rect width="10" height="10" fill="white" transform="translate(5 5)"/>
              </clipPath>
              </defs>
              </svg> Success`,
    };
  },
  mounted() {
    this.$store.dispatch("portfolios/portfolio_list");
    this.modal = new Modal(this.$refs.createNotificationModal);
    const self = this;
    $("#createNotificationModal").on("hide.bs.modal", function (event) {
      self.$emit("set_notification_edit");

      self.$store.commit(
        "investor_configuration/show_notification_modal",
        false
      );
    });
  },
  computed: {
    ...mapState("investor_configuration", [
      "form_action",
      "sidebar_notification_option",
      "create_action_config",
    ]),
  },
  methods: {
    closeModal() {
      this.modal.hide();
    },
    inputsValidated(tab) {
      const data = this.create_action_config;
      if (tab == 2) {
        if ("portfolio_token" in data && data.portfolio_token == null) {
          return "Select one portfolio";
        } else if ("event_type" in data && data.event_type == null) {
          return "Select an event";
        }
      }
      if (tab == 3) {
        if (
          "notification_template" in data &&
          data.notification_template == ""
        ) {
          return "Notification template should not be empty";
        }
      }
      return true;
    },
    nextOption() {
      const validate = this.inputsValidated(this.sidebar_notification_option);
      if (validate == true) {
        if (this.sidebar_notification_option < 4) {
          this.$store.commit(
            "investor_configuration/set_sidebar_notification_option",
            this.sidebar_notification_option + 1
          );
        }
      } else {
        this.$toastr.error(validate, `${this.error}`);
      }
    },
    prevOption() {
      if (this.sidebar_notification_option > 1) {
        this.$store.commit(
          "investor_configuration/set_sidebar_notification_option",
          this.sidebar_notification_option - 1
        );
      }
    },
    save() {
      const data = this.create_action_config;
      if ("channels" in data && data.channels.length == 0) {
        this.$toastr.error(
          "Atleast one channel should be added",
          `${this.error}`
        );
        return false;
      }
      this.$store.dispatch("investor_configuration/create_action", {
        callback: ({ response }) => {
          if (response.error) {
          } else {
            this.reset();
            this.$toastr.success(response.message, `${this.success}`);
            this.modal.hide();
          }
        },
        error: ({ response }) => {
          this.$toastr.error(`${response.data.message}`, `${this.error}`);
        },
      });
    },
    reset() {
      const data = {
        action_type: "notification",
        portfolio_token: null,
        event_type: null,
        is_market: 0,
        notification_template: "",
        channels: [],
      };
      this.$store.commit(
        "investor_configuration/set_create_action_config",
        data
      );
      this.$store.commit(
        "investor_configuration/set_sidebar_notification_option",
        1
      );
    },
  },
  watch: {
    show(newValue) {
      if (newValue) {
        this.modal.show();
      } else {
        this.modal.hide();
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../../../../../styles/pages/investor_configuration/create_notification.scss";
</style>
